import React from 'react'
import { useTranslation } from 'react-i18next'

import { useChecklistForm, useChecklistFormActions } from '../../_form/ChecklistFormHandler'
import CheckboxInput from '../../../../../components/form/CheckboxInput'
import { FlexCol } from '../../../../../components/structure/FlexGrid'
import { useIntegrationList } from '../../_load/IntegrationsLoader'
import TimeSelect from '../../../../../components/form/TimeSelect'
import FormItem from '../../../../../components/form/FormItem'
import SectionsSeparator from './SectionsSeparator'

const SegwareSection = () => {
  const form = useChecklistForm()
  const { handleChange, handleSelectedSegwareTestChange } = useChecklistFormActions()
  const integrations = useIntegrationList()
  const { t } = useTranslation('editChecklist')

  const commonProps = { handleChange, form, t }
  const hasSegwareIntegration = integrations?.find(integration => integration === 'segware')

  if (!hasSegwareIntegration) return null

  return (
    <>
      <SectionsSeparator />
      <FlexCol paddingGutter={1} width="100%">
        <FormItem>
          <CheckboxInput
            label={t('fieldsStep.enabledSegwareTestMode')}
            value={form?.configuration?.enabledSegwareTestMode}
            onChange={value => handleSelectedSegwareTestChange('enabledSegwareTestMode', value)}
          />
        </FormItem>
      </FlexCol>
      {form?.configuration?.enabledSegwareTestMode && (
        <FlexCol paddingGutter={1} width="70%">
          <FormItem
            label={t('fieldsStep.segwarePermittedExecutionTime')}
            field="configuration.segwarePermittedExecutionTime"
            {...commonProps}
          >
            <TimeSelect
              value={form.configuration.segwarePermittedExecutionTime}
              onChange={value => handleSelectedSegwareTestChange('segwarePermittedExecutionTime', value)}
            />
          </FormItem>
        </FlexCol>
      )}
    </>
  )
}

export default SegwareSection
